import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-action-menu",
  "use": "foquz-icon-vue-action-menu-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol preserveAspectRatio=\"none\" overflow=\"visible\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-action-menu\"><path d=\"M7 1v12M1 7h12\" stroke=\"var(--stroke-0, #667799)\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol